import { z } from 'zod';

export const EcifSourceSystem = {
  PolicyCenter: 'PolicyCenter',
  AxiomConnected: 'Axiom Connected',
} as const;
export type EcifSourceSystem = (typeof EcifSourceSystem)[keyof typeof EcifSourceSystem];

export const EcifProductType = {
  Condo: 'Condo',
  DwellingFire: 'Dwelling Fire',
  Homeowner: 'Home Owner',
  HomeWarrantyPlan: 'Home Warranty Plan',
  Tenant: 'Tenant',
} as const;
export type EcifProductType = (typeof EcifProductType)[keyof typeof EcifProductType];
export const EcifProductTypeEnum = z.enum(Object.values(EcifProductType));

export const EcifAgreementStatus = {
  Active: 'Active',
  Pending: 'Pending',
  Cancelled: 'Cancelled',
} as const;
export type EcifAgreementStatus = (typeof EcifAgreementStatus)[keyof typeof EcifAgreementStatus];
const EcifAgreementStatusEnum = z.enum(Object.values(EcifAgreementStatus));

/*
 * Agreement response for ecif-api --> retrieveAgreement
 */
export const EcifAgreementResponseSchema = z.object({
  productType: EcifProductTypeEnum,
  agreementStatus: EcifAgreementStatusEnum,
});

export type EcifAgreementResponse = z.infer<typeof EcifAgreementResponseSchema>;
